export const formatCurrencyGBP = (amount) => {
  const num = Number(amount) || 0;
  try {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  } catch (_) {
    return `£${num.toFixed(2)}`;
  }
};
